define("plans/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('migrate');
    this.route('current');
    this.route('trial_plans');
    this.route('plan', {
      path: '/:plan'
    });
  });
});